/* [EZ] PDP gallery counter — re-adds a "current / total" counter (top-right of the featured
   image) that Horizon drops in thumbnails mode, and keeps it working across variant changes.
   On variant select Horizon REPLACES the whole <media-gallery> node (inside the stable
   .product-information__media wrapper), so we watch that wrapper and re-initialise the counter
   on each replace. The smooth fade-in of the new gallery is CSS (ez-pdp-layout.css).
   Progressive enhancement, no core edits. */
(function () {
  var wrap = null;
  var pending = null;

  function init() {
    var media = wrap || document.querySelector('.product-information__media');
    if (!media) return;
    // Navigation drivers: on mobile Horizon paginates via native dots (inside the desktop:hidden
    // mobile-controls), NOT the thumbnail strip — so our bars/arrows must click the dots to move
    // the slideshow. Fall back to thumbnails (desktop) when no dots are present.
    var dots = media.querySelectorAll('.media-gallery__mobile-controls .slideshow-controls__dots .slideshow-control');
    var thumbs = media.querySelectorAll('.slideshow-controls__thumbnail');
    var nav = dots.length ? dots : thumbs;
    var slides = media.querySelectorAll('slideshow-slide');
    var total = slides.length || nav.length;

    var counter = media.querySelector('.ez-gallery-counter');
    var bars = media.querySelector('.ez-gallery-bars');
    if (total < 2) { if (counter) counter.remove(); if (bars) bars.remove(); return; }
    if (!counter) { counter = document.createElement('div'); counter.className = 'ez-gallery-counter'; }

    // Hero-style bar pagination below the image (CSS shows it on mobile only, hides it on desktop).
    if (!bars) {
      bars = document.createElement('div');
      bars.className = 'ez-gallery-bars';
      var barsHost = media.querySelector('slideshow-component') || media;
      barsHost.appendChild(bars);
    }
    if (bars.children.length !== total) {
      bars.innerHTML = '';
      for (var b = 0; b < total; b++) {
        (function (idx) {
          var bar = document.createElement('button');
          bar.type = 'button';
          bar.className = 'ez-gallery-bar';
          bar.setAttribute('aria-label', 'Go to image ' + (idx + 1));
          // Tapping a bar drives Horizon's native dot/thumbnail (switches the slide); observer re-syncs.
          bar.addEventListener('click', function () { if (nav[idx]) nav[idx].click(); });
          bars.appendChild(bar);
        })(b);
      }
    }

    function activeIndex() {
      for (var i = 0; i < nav.length; i++) {
        if (nav[i].getAttribute('aria-selected') === 'true') return i;
      }
      for (var j = 0; j < slides.length; j++) {
        if (slides[j].getAttribute('aria-hidden') === 'false') return j;
      }
      return 0;
    }

    // Prev/next tap arrows overlaying the image (CSS shows them on mobile only). They wrap around
    // and drive Horizon's native thumbnail like the bars do, so the observer re-syncs everything.
    var arrowHost = media.querySelector('slideshow-component') || media;
    if (!media.querySelector('.ez-gallery-arrow')) {
      ['prev', 'next'].forEach(function (dir) {
        var arrow = document.createElement('button');
        arrow.type = 'button';
        arrow.className = 'ez-gallery-arrow ez-gallery-arrow--' + dir;
        arrow.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        arrow.innerHTML = dir === 'prev'
          ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
        arrow.addEventListener('click', function () {
          var idx = activeIndex();
          var next = dir === 'prev' ? (idx - 1 + total) % total : (idx + 1) % total;
          if (nav[next]) nav[next].click();
        });
        arrowHost.appendChild(arrow);
      });
    }

    function update() {
      var idx = activeIndex();
      counter.textContent = (idx + 1) + ' / ' + total;
      var slide = slides[idx];
      var host = (slide && slide.querySelector('.product-media-container')) || slide || media;
      if (host && counter.parentNode !== host) host.appendChild(counter);
      var bs = bars.children;
      for (var k = 0; k < bs.length; k++) bs[k].classList.toggle('is-active', k === idx);
    }

    update();

    var obs = new MutationObserver(update);
    Array.prototype.forEach.call(nav, function (t) { obs.observe(t, { attributes: true, attributeFilter: ['aria-selected'] }); });
    slides.forEach(function (s) { obs.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] }); });
  }

  function schedule() { clearTimeout(pending); pending = setTimeout(init, 50); }

  function start() {
    wrap = document.querySelector('.product-information__media');
    if (!wrap) return;
    init();
    // Re-init whenever Horizon swaps <media-gallery> (variant change) inside the wrapper.
    new MutationObserver(schedule).observe(wrap, { childList: true });
    window.addEventListener('load', init); // re-run after the slideshow component initialises
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
